export default __webpack_public_path__ + "static/media/facebook-search-results.dc1bd432.jpg";